//
// locale_de.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/de.json';
import localeData from "react-intl/locale-data/de.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_de.js